<template>
    <div class="container fade-in">
        <div class="container bg-dark text-white">
            <h1>
                Página de Administradores cadastro de clientes (Grupo Colab)
            </h1>

            <div class="row">
                <div class="col">
                    <input type="text" placeholder="Cliente Nome" v-model="clienteNome">
                </div>
            </div>

            <!--Luiz Trindade - Campo de usuário-->
            <div class="row">
                <div class="col">
                    <input type="text" placeholder="Usuário Administrador" v-model="admUser">
                </div>
            </div>
            
            <!--Luiz Trindade - Campo de senha-->
            <div class="row">
                <div class="col">
                    <input type="password" placeholder="Senha de Administrador" v-model="admPassword">
                </div>
            </div>
            <br>

            <!--Luiz Trindade - Botão de login-->
            <div class="row">
                <div class="col">
                    <button @click="autenticarLoginAdm()">Login</button>
                </div>
            </div>
        </div>

        <!--Luiz Trindade - Footer ou Rodapé-->
        <footer id="footerSite" class="bg-dark text-white text-center py-3 mt-auto">
            <div class="container">
                <p class="mb-0">© 2024 Grupo Colab. Todos os direitos reservados.</p>
                <p><a href="#" class="text-white">Termos de Serviço</a> | <a href="#" class="text-white">Política de
                        Privacidade</a></p>
                <p class="d-none d-sm-block">Siga-nos nas redes sociais!</p>
                <p>Este site utiliza código licenciado sob a <a href="https://mit-license.org/" target="_blank">Licença MIT</a>.</p>
            </div>
        </footer>
    </div>
</template>

<script>
//Importação do utils.js
import * as utils from '../../../utils.js';

export default {
    name: "ColabFoodLoginAdm",

    data() {
        return {
            clienteNome     : "",
            admUser         : "",
            admPassword     : "",
            codigo_usuario  : "",
            codigo_adm      : ""
        }
    },

    methods: {
        autenticarLoginAdm() {
            utils.loader("start");
            
            //Luiz Trindade - Requisição de autenticação
            this.$http.post(this.$servidorRota+'autenticaradm', {
                cliente         : this.clienteNome,
                codigo_usuario  : utils.gerarHash(this.clienteNome+"1234"),
                codigo_adm      : utils.gerarHash(this.admUser+this.admPassword)
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                if (response.data == 0) {
                    console.log("Adm existe!");
                    utils.informar("Cliente criado com sucesso!");
                } else {
                    utils.informar("Usuário ou senha inválidos!");
                }

                utils.loader();
            })
            .catch(error => {
                console.error('Erro ao registrar o usuário:', error.response ? error.response.data : error.message);
                utils.loader();
            });
        },
    }
}
</script>

<style scoped>
.fade-in {
    opacity: 0;
    /* Começa invisível */
    animation: fadeIn 2.5s forwards;
    /* Aplica a animação */
}
@keyframes fadeIn {
    to {
        opacity: 1;
        /* Finaliza visível */
    }
}
</style>